export enum ConsumerTypeEnum {
  NEW = 'new',
  EXISTED = 'existed',
}
